import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'links/lei-aldir-blanc',
		component: Base,
		children: [
			{
				path: '',
				name: 'LeiAldirBlancList',
				component: List,
				meta: {
					path: '/links/lei-aldir-blanc',
					pai: 'Links',
					title: 'Admin - Lei Aldir Blanc',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Lei Aldir Blanc',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'LeiAldirBlancNovo',
				component: Form,
				meta: {
					path: '/links/lei-aldir-blanc',
					pai: 'Links',
					title: 'Admin - Lei Aldir Blanc - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Lei Aldir Blanc',
						class: '',
						active: false,
						url: '/links/lei-aldir-blanc'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'LeiAldirBlancEditar',
				component: Form,
				meta: {
					path: '/links/lei-aldir-blanc',
					pai: 'Links',
					title: 'Admin - Lei Aldir Blanc - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Lei Aldir Blanc',
						class: '',
						active: false,
						url: '/links/lei-aldir-blanc'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]